var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    { staticStyle: { margin: "1em" } },
    [
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                [
                  _c("sui-grid-column", [
                    _c(
                      "h3",
                      {
                        staticClass: "ui floated header",
                        staticStyle: { "font-weight": "lighter" },
                      },
                      [_vm._v("Investment Strategies")]
                    ),
                  ]),
                  _c("sui-button", {
                    attrs: {
                      basic: "",
                      floated: "right",
                      size: "small",
                      content: "New Investment Strategy",
                      color: "grey",
                    },
                    on: { click: _vm.displayInvestmentStrategyForm },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-table",
        { attrs: { "single-line": "", selectable: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.columns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.investmentStrategies
            ? _c(
                "sui-table-body",
                _vm._l(
                  _vm.investmentStrategies,
                  function (investmentStrategy, index) {
                    return _c(
                      "sui-table-row",
                      { key: index },
                      [
                        _c("sui-table-cell", [_vm._v(_vm._s(index + 1))]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(investmentStrategy.Financial_Account_Name__c)
                          ),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(
                              investmentStrategy.Custodian_Account_Number__c
                            )
                          ),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(investmentStrategy.Account_Master_Code__c)
                          ),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(_vm._s(investmentStrategy.Custodian__c)),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(investmentStrategy.Relationship_Name__c)
                          ),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(investmentStrategy.Investment_Model__c)
                          ),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(_vm._s(investmentStrategy.Status__c)),
                        ]),
                        _c("sui-table-cell", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(investmentStrategy.CreatedDate)
                            )
                          ),
                        ]),
                        _c(
                          "sui-table-cell",
                          [
                            _c(
                              "sui-dropdown",
                              { attrs: { simple: "" } },
                              [
                                _c(
                                  "sui-dropdown-menu",
                                  [
                                    _c(
                                      "sui-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleView(
                                              investmentStrategy
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("View")]
                                    ),
                                    _c(
                                      "sui-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(
                                              investmentStrategy
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Edit")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.investmentStrategy
        ? _c("Modal", {
            attrs: {
              open: _vm.open,
              investmentStrategy: _vm.investmentStrategy,
              toggle: _vm.toggleModal,
            },
            on: { "toggle-modal": _vm.toggleModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }